import axios from 'axios';
import toObjectArray from '@/util/helpers';
import VueToastr from 'vue-toastr';
import Vue from 'vue';
import VModal from 'vue-js-modal';
import NotificationsMixin from '@/mixins/NotificationsMixin';
import StyleMixin from '@/mixins/StyleMixin';
import VueMeta from 'vue-meta';
import algoliasearch from 'algoliasearch/lite';
import InstantSearch from 'vue-instantsearch';
import VueMaterial from 'vue-material';
import dayjs from 'dayjs';
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/tailwind.css';
import i18n from './i18n';

window.algoliasearch = algoliasearch;

Vue.use(InstantSearch);

Vue.use(VueMaterial);

axios.defaults.withCredentials = true;

Vue.config.productionTip = false;

Vue.use(VueToastr, VueMeta, dayjs);

Vue.use(VModal, {
  dynamic: true,
  resizable: true,
  adaptive: true,
  dialog: true,
});

Vue.prototype.formatter = new Intl.NumberFormat('it-IT', {
  style: 'currency',
  currency: process.env.VUE_APP_CURRENCY,
  minimumFractionDigits: 2,
});

Vue.prototype.$toObjectArray = toObjectArray;

Vue.mixin(NotificationsMixin);
Vue.mixin(StyleMixin);

const VueScrollTo = require('vue-scrollto');

Vue.use(VueScrollTo);

store.dispatch('getShop').then(() => {
  store.dispatch('auth/me').then(() => {
    new Vue({
      router,
      store,
      i18n,
      VModal,
      VueMeta,
      render: (h) => h(App),
    }).$mount('#app');
  });
});

store.dispatch('cart/Initialize');
